(function () {
  const initSliders = () => {
    document.querySelectorAll(".swiper-container").forEach((slider) => {
      if (slider.classList.contains("slider_started")) return;
      slider.classList.add("slider_started");
      new Swiper(slider, {
        slidesPerView: 1,
        speed: 250,
        spaceBetween: 0,
        navigation: {
          nextEl: ".product-button-group .swiper-button-next-1",
          prevEl: ".product-button-group .swiper-button-prev-1",
        },
        pagination: {
          el: ".product-card-pagination",
          clickable: true,
        },
      });
    });
  };
  window.initProductCardSliders = initSliders;
  initSliders();
  document.addEventListener("shopify:section:load", initSliders);
})();
